import { render, staticRenderFns } from "./TspComparisonCard.vue?vue&type=template&id=24c90dac"
import script from "./TspComparisonCard.vue?vue&type=script&lang=ts"
export * from "./TspComparisonCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports